"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/MessageTemplates/TemplatesDialog/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);






var _useChatTemplateContext = require('shared/hooks/templates/useChatTemplateContext');
var _useTemplateBlanks = require('shared/hooks/templates/useTemplateBlanks');
var _useTemplateManagement = require('shared/hooks/templates/useTemplateManagement');
var _useTemplateScopes = require('shared/hooks/templates/useTemplateScopes');
var _common = require('shared/selectors/blobject/common/common');
var _myRelations = require('shared/selectors/myRelations');
var _team = require('shared/selectors/team');
var _user = require('shared/selectors/user');
var _templateComposer = require('shared/services/templateComposer');


var _templateList = require('shared/services/templateList');
var _templateResolver = require('shared/services/templateResolver');
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _controls = require('./controls');
var _TemplateEditorModal = require('../TemplateEditorModal');
var _useLatestTemplate = require('../useLatestTemplate');
var _TemplateList = require('./TemplateList'); var _TemplateList2 = _interopRequireDefault(_TemplateList);
var _UsePane = require('./UsePane'); var _UsePane2 = _interopRequireDefault(_UsePane);
var _RecentlyDeleted = require('./RecentlyDeleted'); var _RecentlyDeleted2 = _interopRequireDefault(_RecentlyDeleted);

/* The list's scope filter: every template, or one scope tab. */





















/* Templates, opened from the chat composer (concept A): the list with search
 * and a scope filter on the left, the chosen template on the right. Use shows
 * it filled for this chat, with fields for what's left, and inserts it; Edit
 * and + New edit in place. Recently deleted and Undo live here too: this is
 * everything Settings → Templates did. The chat's org is the one worked on;
 * someone in several orgs can switch org to manage another org's templates,
 * which aren't insertable here. */
const TemplatesDialog = ({ orgKey: chatOrgKey, blobjectKey, initialQuery = '', draft, onInsert, onClose }) => {
  const orgs = _hooks.useAppSelector.call(void 0, _user.selectMyActiveOrgsList)
  const [orgKey, setOrgKey] = _react.useState(chatOrgKey)
  // Unsaved edits, asked about before anything throws them away.
  const dirty = _react.useRef.call(void 0, false)
  const [confirmDiscard, setConfirmDiscard] = _react.useState(null)
  const guard = _react.useCallback.call(void 0, (action) => {
    if (dirty.current) setConfirmDiscard(() => action)
    else action()
  }, [])
  const discard = _react.useCallback.call(void 0, () => {
    const action = confirmDiscard
    dirty.current = false
    setConfirmDiscard(null)
    _optionalChain([action, 'optionalCall', _ => _()])
  }, [confirmDiscard])
  const keepEditing = _react.useCallback.call(void 0, () => setConfirmDiscard(null), [])

  // Esc backs out one level; set by the body for the view it shows.
  const backOut = _react.useRef(onClose)
  const onEscape = _react.useCallback.call(void 0, () => {
    if (confirmDiscard) keepEditing()
    else backOut.current()
  }, [confirmDiscard, keepEditing])
  const close = _react.useCallback.call(void 0, () => guard(onClose), [guard, onClose])
  const switchOrg = _react.useCallback.call(void 0, (next) => guard(() => setOrgKey(next)), [guard])

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: true,
      ariaLabel: "Templates",
      onClose: close,
      onEscape: onEscape,
      className: "templates-dialog",
      bodyClassName: "templates-dialog--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}

      , _react2.default.createElement(OrgTemplates, {
        key: orgKey,
        orgKey: orgKey,
        chatOrgKey: chatOrgKey,
        blobjectKey: blobjectKey,
        initialQuery: initialQuery,
        draft: draft,
        onInsert: onInsert,
        onClose: onClose,
        onRequestClose: close,
        dirty: dirty,
        guard: guard,
        backOut: backOut,
        orgPicker: orgs.length > 1 && (
          _react2.default.createElement(_Form.SimpleSelect, {
            className: "templates-dialog--org",
            'aria-label': "Organization",
            value: orgKey,
            options: orgs.map(o => ({ value: o.OrgKey, label: o.Name })),
            onChange: switchOrg, __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}
          )
        ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}
      )
      ,  confirmDiscard && (
        _react2.default.createElement('div', { className: "templates-dialog--discard", role: "alertdialog", 'aria-label': "Discard changes?" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}}
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}, "Discard your changes to this template?"     )
          , _react2.default.createElement(_controls.DialogButton, { variant: "danger", small: true, onClick: discard, __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}, "Discard")
          , _react2.default.createElement(_controls.DialogButton, { variant: "out", small: true, onClick: keepEditing, __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}, "Keep editing" )
        )
      )
    )
  )
}













const OrgTemplates = ({
  orgKey, chatOrgKey, blobjectKey, initialQuery = '', draft, onInsert, onClose, onRequestClose, dirty, guard, backOut, orgPicker,
}) => {
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const notices = _react.useMemo.call(void 0, () => ({ success: showSuccessBar, warning: showWarningBar }), [showSuccessBar, showWarningBar])
  const { templates, isLoading, recentlyDeleted, undoable, duplicate, remove, restore } = _useTemplateManagement.useTemplateManagement.call(void 0, orgKey, notices)
  const { teams, isAdmin, orgName } = _useTemplateScopes.useTemplateScopes.call(void 0, orgKey)
  const allTeams = _hooks.useAppSelector.call(void 0, _team.selectTeams)
  const myTeamKeys = _hooks.useAppSelector.call(void 0, _myRelations.selectMyTeamKeys)
  const chatTeams = _hooks.useAppSelector.call(void 0, state => _optionalChain([_common.selectBlobjectByKey.call(void 0, state, blobjectKey), 'optionalAccess', _2 => _2.TeamSubscribers]))
  const inChatOrg = orgKey === chatOrgKey
  // "Save draft as template" only in the chat's own org: the draft's patient
  // details are found among that org's patients, and it's saved there.
  const chatDraft = inChatOrg ? draft : ''

  // The teams whose templates can go into this chat: as in the "/" list, a
  // member's own teams, or for an admin the teams in this chat.
  const usableTeamKeys = _react.useMemo.call(void 0, 
    () => !inChatOrg ? [] : isAdmin ? Object.keys(_nullishCoalesce(chatTeams, () => ( {}))) : myTeamKeys,
    [inChatOrg, isAdmin, chatTeams, myTeamKeys],
  )
  const usable = _react.useCallback.call(void 0, 
    (t) => inChatOrg && (t.Scope !== 'team' || (!!t.TeamKey && usableTeamKeys.includes(t.TeamKey))),
    [inChatOrg, usableTeamKeys],
  )
  // Tabs: the usable teams; the other teams I manage go under "More teams".
  const tabTeams = _react.useMemo.call(void 0, () => inChatOrg ? teams.filter(t => usableTeamKeys.includes(t.TeamKey)) : teams, [inChatOrg, teams, usableTeamKeys])
  const moreTeams = _react.useMemo.call(void 0, () => inChatOrg ? teams.filter(t => !usableTeamKeys.includes(t.TeamKey)) : [], [inChatOrg, teams, usableTeamKeys])

  const [filter, setFilter] = _react.useState('all')
  const [query, setQuery] = _react.useState.call(void 0, initialQuery)
  const [view, setView] = _react.useState({ kind: 'use' })
  const [selectedKey, setSelectedKey] = _react.useState(null)
  const [deleting, setDeleting] = _react.useState.call(void 0, false)

  // What this chat fills a template with.
  const context = _useChatTemplateContext.useChatTemplateContext.call(void 0, chatOrgKey, blobjectKey)
  const fill = _react.useMemo.call(void 0, () => ({ values: _templateResolver.templateValues.call(void 0, context), defaults: _templateResolver.templateDefaults.call(void 0, context) }), [context])
  const fillFor = _react.useCallback.call(void 0, 
    (patientKey) => ({ values: _templateResolver.templateValues.call(void 0, context, patientKey), defaults: _templateResolver.templateDefaults.call(void 0, context, patientKey) }),
    [context],
  )
  // The editor's Preview reads as this chat would; another org's, a sample patient.
  const previewContext = inChatOrg ? context : undefined
  const teamNames = _react.useMemo.call(void 0, 
    () => Object.fromEntries(Object.values(_nullishCoalesce(allTeams, () => ( {}))).filter(Boolean).map(t => [t.TeamKey, t.Name])),
    [allTeams],
  )

  // "All" is what can be used here; a team from "More teams" lists its own.
  const filtered = _react.useMemo.call(void 0, 
    () => filter === 'all' ? templates.filter(t => usable(t) || !inChatOrg) : templates.filter(_templateList.inTemplateTab.call(void 0, filter)),
    [templates, filter, usable, inChatOrg],
  )
  const rows = _react.useMemo.call(void 0, 
    () => _templateComposer.pickerRows.call(void 0, filtered, query, inChatOrg ? fill.values : {}, teamNames, inChatOrg ? fill.defaults : {}),
    [filtered, query, inChatOrg, fill, teamNames],
  )
  // The first row is chosen until another is; one that drops out of the list
  // (filtered away, deleted) hands over to the first.
  const selected = _nullishCoalesce(_nullishCoalesce(rows.find(r => r.template.TemplateKey === selectedKey), () => ( rows[0])), () => ( null))
  const selectedTemplate = _nullishCoalesce(_optionalChain([selected, 'optionalAccess', _3 => _3.template]), () => ( null))

  // The values typed for the chosen template, and who it's for in a chat with
  // several patients; another template starts over.
  const [typed, setTyped] = _react.useState({})
  const [patientKey, setPatientKey] = _react.useState(null)
  const shownKey = _optionalChain([selectedTemplate, 'optionalAccess', _4 => _4.TemplateKey])
  _react.useEffect.call(void 0, () => {
    setTyped({})
    setPatientKey(null)
  }, [shownKey])
  const onType = _react.useCallback.call(void 0, (name, value) => setTyped(t => ({ ...t, [name]: value })), [])
  const needsPatient = !!selectedTemplate && inChatOrg && _templateResolver.needsPatientChoice.call(void 0, selectedTemplate.Body, context)
  const shownFill = patientKey ? fillFor(patientKey) : fill

  const isEditing = view.kind === 'edit' || view.kind === 'new' || view.kind === 'fromDraft'
  const toUse = _react.useCallback.call(void 0, () => {
    dirty.current = false
    setDeleting(false)
    setView({ kind: 'use' })
  }, [dirty])
  _react.useLayoutEffect.call(void 0, () => {
    backOut.current = deleting
      ? () => setDeleting(false)
      : isEditing ? () => guard(toUse)
        : view.kind === 'deleted' ? toUse
          : onClose
  })

  const choose = _react.useCallback.call(void 0, (key) => {
    setSelectedKey(key)
    setDeleting(false)
    if (view.kind === 'deleted') setView({ kind: 'use' })
  }, [view.kind])

  const tab = filter === 'all' ? 'mine' : filter
  const startNew = _react.useCallback.call(void 0, (name = '') => guard(() => {
    setDeleting(false)
    setView({ kind: 'new', draft: { Name: name, Body: '', choice: _templateList.newTemplateChoice.call(void 0, tab) } })
  }), [guard, tab])
  const startFromDraft = _react.useCallback.call(void 0, () => guard(() => {
    setDeleting(false)
    setView({ kind: 'fromDraft', choice: _templateList.newTemplateChoice.call(void 0, tab) })
  }), [guard, tab])
  const startEdit = _react.useCallback.call(void 0, () => setView({ kind: 'edit' }), [])
  const showDeleted = _react.useCallback.call(void 0, () => guard(() => {
    setDeleting(false)
    setView({ kind: 'deleted' })
  }), [guard])

  const onSaved = _react.useCallback.call(void 0, (t) => {
    dirty.current = false
    setSelectedKey(t.TemplateKey)
    showSuccessBar(`Saved "${t.Name}"`)
  }, [dirty, showSuccessBar])
  const onDirtyChange = _react.useCallback.call(void 0, (d) => { dirty.current = d }, [dirty])

  const confirmDelete = _react.useCallback.call(void 0, () => {
    if (!selectedTemplate) return
    remove(selectedTemplate)
    setSelectedKey(null)
    toUse()
  }, [selectedTemplate, remove, toUse])
  const onDuplicate = _react.useCallback.call(void 0, (t) => duplicate(t), [duplicate])

  // Insert: the latest version, with the values typed into the fields.
  // Anything left goes in as a blank to fill in the composer.
  const { latest, fetching, gone } = _useLatestTemplate.useLatestTemplate.call(void 0, orgKey)
  const pane = _react.useRef(null)
  const insert = _react.useCallback.call(void 0, async () => {
    if (!selectedTemplate || !usable(selectedTemplate)) return
    if (needsPatient && !patientKey) {
      _optionalChain([pane, 'access', _5 => _5.current, 'optionalAccess', _6 => _6.querySelector, 'call', _7 => _7('input[type="radio"]'), 'optionalAccess', _8 => _8.focus, 'call', _9 => _9()])
      return
    }
    const picked = await latest(selectedTemplate)
    if (!picked) return
    const values = { ...shownFill.values }
    Object.entries(typed).forEach(([name, value]) => { if (value.trim()) values[name] = value })
    onInsert(picked.template, { values, defaults: shownFill.defaults }, picked.notice)
  }, [selectedTemplate, usable, needsPatient, patientKey, latest, shownFill, typed, onInsert])

  // One underline tab per scope: All, Mine, the teams, Org. An admin's teams
  // that aren't in this chat come last; their templates are edit-only here.
  const filterTabs = _react.useMemo.call(void 0, () => [
    { value: 'all' , label: 'All' },
    { value: 'mine' , label: 'Mine' },
    ...tabTeams.map(t => ({ value: `team:${t.TeamKey}` , label: t.Name })),
    { value: 'org' , label: 'Org' },
    ...moreTeams.map(t => ({ value: `team:${t.TeamKey}` , label: t.Name })),
  ], [tabTeams, moreTeams])

  const segChange = _react.useCallback.call(void 0, (next) => {
    if (next === 'edit') startEdit()
    else guard(toUse)
  }, [startEdit, guard, toUse])

  let detail
  if (view.kind === 'deleted') {
    detail = _react2.default.createElement(_RecentlyDeleted2.default, { templates: recentlyDeleted, teamNames: teamNames, onRestore: restore, __self: this, __source: {fileName: _jsxFileName, lineNumber: 305}} )
  } else if (view.kind === 'new') {
    detail = (
      _react2.default.createElement(EditorPane, { title: "New template" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 308}}
        , _react2.default.createElement(_TemplateEditorModal.TemplateEditor, {
          orgKey: orgKey,
          draft: view.draft,
          previewContext: previewContext,
          layout: "pane",
          onClose: toUse,
          onSaved: onSaved,
          onDirtyChange: onDirtyChange,
          renderControls: editorControls(toUse, null, 'Save'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 309}}
        )
      )
    )
  } else if (view.kind === 'fromDraft') {
    detail = (
      _react2.default.createElement(EditorPane, { title: "New template" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 323}}
        , _react2.default.createElement(DraftEditor, {
          orgKey: orgKey,
          blobjectKey: blobjectKey,
          text: draft,
          choice: view.choice,
          onClose: toUse,
          onSaved: onSaved,
          onDirtyChange: onDirtyChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 324}}
        )
      )
    )
  } else if (view.kind === 'edit' && selectedTemplate) {
    detail = (
      _react2.default.createElement(EditorPane, {
        title: "Edit template" ,
        toggle: _react2.default.createElement(_controls.Segmented, { label: "Template view" , value: "edit", options: USE_EDIT, onChange: segChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 339}} ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 337}}

        ,  !selectedTemplate.CanManage && (
          _react2.default.createElement('p', { className: "tdlg-note tdlg-note--brand" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 342}}
            , _react2.default.createElement('span', { 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 343}}, "ⓘ")
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 344}}, "You can edit this text. Only its author and admins can change who uses it or delete it."                 )
          )
        )
        , _react2.default.createElement(_TemplateEditorModal.TemplateEditor, {
          key: selectedTemplate.TemplateKey,
          orgKey: orgKey,
          template: selectedTemplate,
          previewContext: previewContext,
          layout: "pane",
          onClose: toUse,
          onSaved: onSaved,
          onDirtyChange: onDirtyChange,
          renderControls: editorControls(toUse, (
            _react2.default.createElement(EditorExtras, {
              template: selectedTemplate,
              deleting: deleting,
              onDelete: setDeleting,
              onConfirmDelete: confirmDelete,
              onDuplicate: onDuplicate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 357}}
            )
          ), 'Save changes', deleting), __self: this, __source: {fileName: _jsxFileName, lineNumber: 347}}
        )
      )
    )
  } else if (selected) {
    detail = (
      _react2.default.createElement(_UsePane2.default, {
        row: selected,
        context: context,
        fill: shownFill,
        typed: typed,
        onType: onType,
        needsPatient: needsPatient,
        patientKey: patientKey,
        onPatient: setPatientKey,
        insertable: usable(selected.template),
        busy: _optionalChain([fetching, 'optionalAccess', _10 => _10.key]) === selected.template.TemplateKey,
        gone: gone,
        onInsert: insert,
        onToggle: segChange,
        onDuplicate: onDuplicate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 370}}
      )
    )
  } else {
    // An empty list says what to do on its own.
    detail = null
  }

  // The header's muted line: whose values Use fills in, or, while managing,
  // the org (with the switcher for someone in several).
  const managing = view.kind !== 'use' || !inChatOrg
  const showOrgPicker = managing && !!orgPicker
  const headerContext = !inChatOrg
    ? _react2.default.createElement('span', { className: "templates-dialog--ctx", __self: this, __source: {fileName: _jsxFileName, lineNumber: 397}}, "Manage only: not this chat's organization"     )
    : !managing ? _react2.default.createElement(ChatLine, { context: context, __self: this, __source: {fileName: _jsxFileName, lineNumber: 398}} ) : showOrgPicker ? null : _react2.default.createElement('span', { className: "templates-dialog--ctx", __self: this, __source: {fileName: _jsxFileName, lineNumber: 398}},  orgName )
  // No templates at all yet: the empty state takes the whole dialog.
  const nothingYet = !isLoading && templates.length === 0 && view.kind === 'use' && !query.trim()

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "templates-dialog--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 404}}
        , _react2.default.createElement('h3', { className: "templates-dialog--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 405}}, "Templates")
        ,  headerContext 
        ,  showOrgPicker && orgPicker 
        , _react2.default.createElement('span', { className: "templates-dialog--head-gap", __self: this, __source: {fileName: _jsxFileName, lineNumber: 408}} )
        ,  !isEditing && _react2.default.createElement(_controls.DialogButton, { variant: "out", small: true, onClick: () => startNew(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 409}}, "+ New" ) 
        , _react2.default.createElement('button', { type: "button", className: "templates-dialog--close", 'aria-label': "Close", onClick: onRequestClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 410}}
          , _react2.default.createElement('svg', { viewBox: "0 0 16 16"   , 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 411}}, _react2.default.createElement('path', { d: "M4 4l8 8M12 4l-8 8"    , stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", __self: this, __source: {fileName: _jsxFileName, lineNumber: 411}} ))
        )
      )
      ,  nothingYet
        ? (
          _react2.default.createElement('div', { className: "templates-dialog--nothing", __self: this, __source: {fileName: _jsxFileName, lineNumber: 416}}
            , _react2.default.createElement(_TemplateList2.default, {
              rows: rows,
              selectedKey: null,
              locked: false,
              isLoading: false,
              query: "",
              draft: chatDraft,
              onChoose: choose,
              onNew: startNew,
              onNewFromDraft: startFromDraft, __self: this, __source: {fileName: _jsxFileName, lineNumber: 417}}
            )
            ,  recentlyDeleted.length > 0 && (
              _react2.default.createElement('button', { type: "button", className: "templates-dialog--deleted-link", onClick: showDeleted, __self: this, __source: {fileName: _jsxFileName, lineNumber: 429}}
                , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 430}}, "delete_outline"), "Recently deleted ("
                  ,  recentlyDeleted.length , ")"
              )
            )
          )
          )
        : (
      _react2.default.createElement('div', { className: "templates-dialog--split", __self: this, __source: {fileName: _jsxFileName, lineNumber: 437}}
        , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'templates-dialog--list-column', isEditing && 'templates-dialog--locked'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 438}}
          , _react2.default.createElement('div', { className: "templates-dialog--search-wrap", __self: this, __source: {fileName: _jsxFileName, lineNumber: 439}}
            , _react2.default.createElement('label', { className: "tdlg-search", __self: this, __source: {fileName: _jsxFileName, lineNumber: 440}}
              , _react2.default.createElement('svg', { className: "tdlg-search--icon", viewBox: "0 0 16 16"   , 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 441}}
                , _react2.default.createElement('circle', { cx: "7", cy: "7", r: "5", fill: "none", stroke: "currentColor", strokeWidth: "1.8", __self: this, __source: {fileName: _jsxFileName, lineNumber: 442}} )
                , _react2.default.createElement('path', { d: "M11 11l3.5 3.5"  , stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", __self: this, __source: {fileName: _jsxFileName, lineNumber: 443}} )
              )
              , _react2.default.createElement('input', {
                className: "tdlg-search--input",
                type: "search",
                'aria-label': "Search templates" ,
                placeholder: "Search templates" ,
                value: query,
                disabled: isEditing,
                onChange: e => setQuery(e.target.value),
                onKeyDown: e => listKeys(e, rows, _nullishCoalesce(_optionalChain([selected, 'optionalAccess', _11 => _11.template, 'access', _12 => _12.TemplateKey]), () => ( null)), setSelectedKey, insert),
                autoFocus: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 445}}
              )
            )
          )
          , _react2.default.createElement('div', { className: "tdlg-tabs", role: "tablist", 'aria-label': "Scope", __self: this, __source: {fileName: _jsxFileName, lineNumber: 458}}
            ,  filterTabs.map(t => (
              _react2.default.createElement('button', {
                key: t.value,
                type: "button",
                role: "tab",
                'aria-selected': t.value === filter,
                disabled: isEditing,
                className: _classBuilder2.default.call(void 0, 'tdlg-tabs--tab', t.value === filter && 'tdlg-tabs--on'),
                onClick: () => setFilter(t.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 460}}

                ,  t.label 
              )
            ))
          )
          ,  filter === 'org' && _react2.default.createElement('p', { className: "templates-dialog--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 473}},  _templateList.orgTabHint.call(void 0, orgName) ) 
          , _react2.default.createElement(_TemplateList2.default, {
            rows: rows,
            selectedKey: isEditing && view.kind !== 'edit' ? null : _nullishCoalesce(_optionalChain([selected, 'optionalAccess', _13 => _13.template, 'access', _14 => _14.TemplateKey]), () => ( null)),
            locked: isEditing,
            isLoading: isLoading && templates.length === 0,
            query: query,
            draft: chatDraft,
            onChoose: choose,
            onNew: startNew,
            onNewFromDraft: startFromDraft, __self: this, __source: {fileName: _jsxFileName, lineNumber: 474}}
          )
          ,  recentlyDeleted.length > 0 && (
            _react2.default.createElement('button', { type: "button", className: "templates-dialog--deleted-link", disabled: isEditing, onClick: showDeleted, __self: this, __source: {fileName: _jsxFileName, lineNumber: 486}}
              , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 487}}, "delete_outline"), "Recently deleted ("
                ,  recentlyDeleted.length , ")"
            )
          )
        )
        , _react2.default.createElement('div', { ref: pane, className: "templates-dialog--pane", __self: this, __source: {fileName: _jsxFileName, lineNumber: 492}}
          ,  detail 
        )
      )
          )
      
      ,  undoable && (
        _react2.default.createElement('div', { className: "tdlg-toast", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 499}}
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 500}}, "Template deleted." )
          , _react2.default.createElement('button', { type: "button", className: "tdlg-toast--undo", onClick: () => restore(undoable), __self: this, __source: {fileName: _jsxFileName, lineNumber: 501}}, "Undo")
        )
      )
    )
  )
}

const USE_EDIT = [{ value: 'use' , label: 'Use' }, { value: 'edit' , label: 'Edit' }]

/* Arrow keys move through the list and Enter acts on the chosen row; the
 * search box keeps focus, as in the "/" list. */
const listKeys = (
  e,
  rows,
  selectedKey,
  select,
  onEnter,
) => {
  if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
    e.preventDefault()
    if (!rows.length) return
    const at = Math.max(0, rows.findIndex(r => r.template.TemplateKey === selectedKey))
    const next = (at + (e.key === 'ArrowDown' ? 1 : rows.length - 1)) % rows.length
    select(rows[next].template.TemplateKey)
  } else if (e.key === 'Enter') {
    e.preventDefault()
    onEnter()
  }
}

/* "Filling for Maria Lopez · sending as WIC": whose values the preview and
 * Insert use. */
const ChatLine = ({ context }) => {
  const names = context.patients.map(p => `${p.FirstName} ${p.LastName}`.trim()).filter(Boolean)
  return (
    _react2.default.createElement('span', { className: "templates-dialog--ctx", __self: this, __source: {fileName: _jsxFileName, lineNumber: 536}}
      ,  names.length > 0 && _react2.default.createElement(_react2.default.Fragment, null, "Filling for "  , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 537}},  names.join(' / ') )) 
      ,  names.length > 0 && context.teamName && ' · ' 
      ,  context.teamName && _react2.default.createElement(_react2.default.Fragment, null, "sending as "  , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 539}},  context.teamName )) 
    )
  )
}

// Cmd/Ctrl+Enter anywhere in the editor saves (not labelled anywhere).
const saveOnModEnter = (e) => {
  if (e.key !== 'Enter' || !(e.metaKey || e.ctrlKey)) return
  e.preventDefault()
  _optionalChain([e, 'access', _15 => _15.currentTarget, 'access', _16 => _16.querySelector, 'call', _17 => _17('.templates-dialog--save'), 'optionalAccess', _18 => _18.click, 'call', _19 => _19()])
}

/* Edit and New in the right pane: a scrolling body with the editor's fields
 * and a footer pinned to the bottom (the editor's controls stick there). */
const EditorPane = ({ title, toggle, children }) => (
  _react2.default.createElement('section', { className: "templates-dialog--editor message-template-editor" , 'aria-label': title, onKeyDown: saveOnModEnter, __self: this, __source: {fileName: _jsxFileName, lineNumber: 554}}
    , _react2.default.createElement('div', { className: "templates-dialog--pane-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 555}}
      , _react2.default.createElement('h4', { className: "templates-dialog--editor-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 556}},  title )
      ,  toggle 
    )
    ,  children 
  )
)

/* The editor's footer in the dialog: Delete or Duplicate to Mine on the
 * left, Cancel and Save on the right. Confirming a delete takes the whole
 * footer. */
const editorControls = (onCancel, extras, saveLabel, confirming = false) =>
  ({ save, isSaving }) => (
    _react2.default.createElement('div', { className: "templates-dialog--foot templates-dialog--editor-foot" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 568}}
      , _react2.default.createElement('div', { className: "templates-dialog--foot-start", __self: this, __source: {fileName: _jsxFileName, lineNumber: 569}},  extras )
      ,  !confirming && (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement(_controls.DialogButton, { variant: "ghost", onClick: onCancel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 572}}, "Cancel")
          , _react2.default.createElement(_controls.DialogButton, { className: "templates-dialog--save", busy: isSaving, onClick: save, __self: this, __source: {fileName: _jsxFileName, lineNumber: 573}},  saveLabel )
        )
      )
    )
  )









/* Only its author and the org's admins (CanManage) delete a template; anyone
 * else it's shared with can copy it to Mine. */
const EditorExtras = ({ template, deleting, onDelete, onConfirmDelete, onDuplicate }) => {
  if (!template.CanManage) {
    return _react2.default.createElement(_controls.DialogButton, { variant: "out", small: true, onClick: () => onDuplicate(template), __self: this, __source: {fileName: _jsxFileName, lineNumber: 591}}, "Duplicate to Mine"  )
  }
  if (!deleting) return _react2.default.createElement(_controls.DialogButton, { variant: "danger", small: true, onClick: () => onDelete(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 593}}, "Delete")
  return (
    _react2.default.createElement('div', { className: "templates-dialog--confirm-delete", role: "alertdialog", 'aria-label': "Delete template" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 595}}
      , _react2.default.createElement('span', { className: "templates-dialog--confirm-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 596}}, "Delete \"" ,  template.Name , "\"? People who could use it won't see it anymore."         )
      , _react2.default.createElement(_controls.DialogButton, { variant: "danger", small: true, onClick: onConfirmDelete, __self: this, __source: {fileName: _jsxFileName, lineNumber: 597}}, "Delete")
      , _react2.default.createElement(_controls.DialogButton, { variant: "ghost", small: true, onClick: () => onDelete(false), __self: this, __source: {fileName: _jsxFileName, lineNumber: 598}}, "Cancel")
    )
  )
}











/* "Save draft as template": the composer's text, with the patient details
 * offered as blanks, as Save as template does for a sent message. */
const DraftEditor = ({ orgKey, blobjectKey, text, choice, onClose, onSaved, onDirtyChange }) => {
  const context = _useChatTemplateContext.useChatTemplateContext.call(void 0, orgKey, blobjectKey)
  const conversationKey = _hooks.useAppSelector.call(void 0, state => _optionalChain([_common.selectBlobjectByKey.call(void 0, state, blobjectKey), 'optionalAccess', _20 => _20.WrappedKey])) 
  const blanks = _useTemplateBlanks.useTemplateBlanks.call(void 0, {
    orgKey, conversationKey, text, staffName: _nullishCoalesce(context.senderName, () => ( '')), onlyOnePatient: !!_templateResolver.onlyPatient.call(void 0, context),
  })
  // Opening it is already a change worth keeping.
  _react.useEffect.call(void 0, () => onDirtyChange(true), [onDirtyChange])
  return (
    _react2.default.createElement(_TemplateEditorModal.TemplateEditor, {
      orgKey: orgKey,
      draft: { Name: '', Body: blanks.body, choice },
      blanks: blanks,
      previewContext: context,
      layout: "pane",
      onClose: onClose,
      onSaved: onSaved,
      renderControls: editorControls(onClose, null, 'Save'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 624}}
    )
  )
}

exports. default = TemplatesDialog
